import { QUERY_PARAM_KEYS, LINK_FROM_APP_REFERRERS } from '$lib/utils/constants';
import { getQueryParamByKey } from '$lib/utils/browser';

/**
 * @type {{ [key: string]: import('$lib/utils/page').PageCondition }}
 */
const pageConditions = {
	/**
	 * Giveaway shown inside the product webview / in-app browser.
	 * Detected via `?referrer=abcm2app` on the URL.
	 */
	inApp: {
		condition: async () => {
			const url = new URL(window.location.href);
			const referrer = getQueryParamByKey(url, QUERY_PARAM_KEYS.REFERRER);
			return referrer === LINK_FROM_APP_REFERRERS.APP_2_0;
		},
		resolve: async () => await import('../_in-app/Page.svelte'),
	},
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser-2-0-rebrand/Page.svelte'),
	},
};

export { pageConditions };
